import { Box, Text } from '@wix/design-system';
import React from 'react';
import AfnicLogo from '../../assets/afnic-logo.svg';
import { useFrenchPremiumExperience } from '../../hooks/useFrenchPremiumExperience';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

export const AfnicSection = () => {
  const isFrenchPremiumExperience = useFrenchPremiumExperience();
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  if (!isFrenchPremiumExperience) {
    return null;
  }

  return (
    <Box width="100%" maxWidth="1320px" direction="vertical" dataHook="afnic-section">
      <Box
        width="100%"
        direction="horizontal"
        align="center"
        verticalAlign="middle"
        paddingTop="60px"
        paddingBottom="60px"
        paddingLeft="SP6"
        paddingRight="SP6"
        gap="24px"
      >
        <Box width="88px" height="88px" minWidth="88px">
          <AfnicLogo />
        </Box>
        <Box direction="vertical" gap="SP2" width="550px">
          <Text size="medium" weight="bold">
            {t('Advanced.Features_Values_Afnic_FR_PP_header')}
          </Text>
          <Text size="small" weight="normal">
            {t('Advanced.Features_Values_Afnic_FR_PP_subheader')}
          </Text>
        </Box>
      </Box>
      <Box
        height="1px"
        width="100%"
        backgroundColor="#162D3D"
        dataHook="afnic-section-divider"
      />
    </Box>
  );
};
